import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section aria-labelledby="owner-reviews" className="my-12" data-id="element-38" data-mp="3kqw3yjl330fl">
      <div className="border-b-2 border-forest pb-3" data-id="element-39" data-mp="3fyvyycq5phc5">
        <p className="font-sans text-xs font-bold uppercase tracking-widest text-forest-mid" data-id="element-40" data-mp="3fxkx4ig9ujno">
          From other owners
        </p>
        <h2 id="owner-reviews" className="mt-1 font-serif text-2xl font-semibold leading-snug text-forest sm:text-[28px]" data-id="element-41" data-mp="36zinxfmdwkpb">
          The dogs people said could never be contained
        </h2>
      </div>

      <ul className="mt-6 space-y-5" data-id="element-42" data-mp="2x1l2ezvwt20e">
        {testimonials.map(review => <li key={review.name} className="flex flex-col gap-4 border border-forest-line bg-paper-tint p-5 sm:flex-row" data-id="element-43" data-mp="2s2rwptmv6fas">
            <img src={review.photo} alt={`${review.name} with her ${review.breed.toLowerCase()}`} className="h-28 w-28 shrink-0 rounded-sm object-cover sm:h-24 sm:w-24" loading="lazy" data-id="element-44" data-mp="v72fffjqcsi4" />
            <div className="flex flex-1 flex-col" data-id="element-45" data-mp="m5sz6h4kg0o5">
              <div className="flex items-center gap-1" aria-label="5 out of 5 stars" data-id="element-46" data-mp="77s8q2mgih1e">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-forest-mid text-forest-mid" aria-hidden="true" data-id="element-47" data-mp="c7wmvlzw6zog" />)}
              </div>
              <p className="mt-2 font-serif text-[17px] italic leading-relaxed text-ink" data-id="element-48" data-mp="14ur50c98lmyr">
                “{review.quote}”
              </p>
              <p className="mt-auto pt-3 font-sans text-sm font-semibold text-forest" data-id="element-49" data-mp="v5fy8w9toue1">
                {review.name}, {review.age}
                <span className="font-normal text-ink-soft" data-id="element-50" data-mp="1iuigo6ca6r9l">
                  {' '}
                  · {review.breed} · {review.property}
                </span>
              </p>
            </div>
          </li>)}
      </ul>
    </section>;
}